import './rx';

import ContactUs from './components/ContactUs/ContactUs';
import CompleteRegistration from './components/CompleteRegistration/CompleteRegistration';
import VerifyAuctionAccess from './components/VerifyAuctionAccess/VerifyAuctionAccess';
import CreateNewAccount from './components/CreateNewAccount/CreateNewAccount';
import Landing from './components/Landing/Landing';

import { FEATURE } from './constants/features';
import { EVENT } from '../../shared/js/constants';

const { flex } = window;
const { React } = flex.lib;

const {
    ResetPassword,
    ForgotPassword,
    ForgotUsername,
    Register,
    UpdateSecuritySettings
} = flex.components;

class App extends React.Component {
    reroute = () => {
        flex.browserHistory.go();
    }

    render() {
        const isVerifyAuctionAccessEnabled = flex.isFeatureToggleEnabled(
            FEATURE.VERIFY_WITH_AUCTION_ACCESS
        );

        return (
            <flex.lib.Router.Router history={flex.browserHistory}>
                <div>
                    <flex.lib.Router.Switch>
                        <flex.lib.Router.Route path="/login" render={this.routeLogin} />
                        <flex.lib.Router.Route path="/logout" render={this.routeLogout} />
                        <flex.lib.Router.Route path="/ssoportal" render={this.routeSsoPortal} />
                        <flex.lib.Router.Route path="/forgotpassword" render={this.routeForgotPassword} />
                        <flex.lib.Router.Route path="/forgotusername" render={this.routeForgotUsername} />
                        <flex.lib.Router.Route path="/register" render={this.routeRegister} />
                        <flex.lib.Router.Route path="/completeregistration/:registrationToken" render={this.routeCompleteRegistration} />
                        {isVerifyAuctionAccessEnabled && <flex.lib.Router.Route path="/verifyauctionaccess/:registrationToken" render={this.routeVerifyAuctionAccess} />}
                        <flex.lib.Router.Route path="/createnewaccount/:registrationToken" render={this.routeCreateNewAccount} />
                        <flex.lib.Router.Route path="/resetpassword/:passwordResetToken?/:userId?/:code?" render={this.routeResetPassword} />
                        <flex.lib.Router.Route path="/updatesecuritysettings/:updateSecuritySettingsToken?/:userId?" render={this.routeUpdateSecuritySettings} />
                        <flex.lib.Router.Route path="/contactus" render={this.routeContactUs} />
                        <flex.lib.Router.Route path="/oauthcallback" render={this.routeOAuthCallback} />
                        <flex.lib.Router.Route path="/oauthcallbackregistration" render={this.routeOAuthCallback} />
                        <flex.lib.Router.Route path="/landing" render={this.routeLanding} />
                        <flex.lib.Router.Route render={this.reroute} />
                    </flex.lib.Router.Switch>
                </div>
            </flex.lib.Router.Router>
        );
    }

    routeLogin = () => {
        const store = this.props.store || {};
        const orgCode = store.appContext.app.org.code || '';
        var loginContext = require.context("./components/Login", false);
        const loginComponentKey = loginContext.keys().find((widgetKey, i) => {
            return widgetKey.toLowerCase() == './' + orgCode.toLowerCase();
        });

        if (!loginComponentKey) {
            return (
                <div>
                    <flex.components.Header session={store.session} appContext={store.appContext} topNav={this.props.topNav} />
                    <flex.components.Login session={store.session} />
                    <flex.components.Footer session={store.session} appContext={store.appContext} />
                </div>
            );
        } else {
            const Login = loginContext(loginComponentKey);

            return (<Login session={store.session} appContext={store.appContext} />);
        }
    }

    routeLogout = () => {
        flex.trigger(EVENT.GLOBAL.SESSION_LOGGED_OUT);

        return <flex.lib.Router.Redirect to="/" />;
    };

    routeSsoPortal = () => {
        const store = this.props.store || {};

        return (
            <div>
                <flex.components.SSOPortal session={store.session} appContext={store.appContext} store={store}/>
            </div>
        );
    }

    routeForgotPassword = () => {
        const store = this.props.store || {};

        return (
            <div>
                <flex.components.Header session={store.session} appContext={store.appContext} topNav={this.props.topNav}></flex.components.Header>
                <ForgotPassword />
                <flex.components.Footer session={store.session} appContext={store.appContext}></flex.components.Footer>
            </div>
        );
    }

    routeForgotUsername = () => {
        const store = this.props.store || {};

        return (
            <div>
                <flex.components.Header session={store.session} appContext={store.appContext} topNav={this.props.topNav}></flex.components.Header>
                <ForgotUsername />
                <flex.components.Footer session={store.session} appContext={store.appContext}></flex.components.Footer>
            </div>
        );
    }

    routeResetPassword = ({ match }) => {
        const { passwordResetToken, userId, code } = match.params;
        const store = this.props.store || {};

        return (<ResetPassword passwordResetToken={passwordResetToken} userId={userId} errorCode={code} store={store}/>);
    }

    routeUpdateSecuritySettings = ({ match }) => {
        const { updateSecuritySettingsToken, userId } = match.params;
        const store = this.props.store || {};

        return (
            <>
                <flex.components.Header session={store.session} appContext={store.appContext} topNav={this.props.topNav}></flex.components.Header>
                <UpdateSecuritySettings updateSecuritySettingsToken={updateSecuritySettingsToken} userId={userId} store={store}/>
                <flex.components.Footer session={store.session} appContext={store.appContext}></flex.components.Footer>
            </>
        );
    }

    routeRegister = () => {
        const store = this.props.store || {};

        return (
            <div>
                <flex.components.Header session={store.session} appContext={store.appContext} topNav={this.props.topNav}></flex.components.Header>
                <Register store={store} />
                <flex.components.Footer session={store.session} appContext={store.appContext}></flex.components.Footer>
            </div>
        );
    }

    routeCompleteRegistration = ({ match }) => {
        const { registrationToken } = match.params;
        const {
            appContext,
            session,
            completeRegistration
        } = this.props.store;

        return (
            <>
                <flex.components.Header
                    session={session}
                    appContext={appContext}
                    topNav={this.props.topNav}
                />
                <CompleteRegistration
                    {...completeRegistration}
                    registrationToken={registrationToken}
                />
                <flex.components.Footer
                    session={session}
                    appContext={appContext}
                />
            </>
        );
    };

    routeVerifyAuctionAccess = ({ match }) => {
        const { registrationToken } = match.params;
        const { appContext, session, verifyAuctionAccess } = this.props.store;

        return (
            <>
                <flex.components.Header
                    session={session}
                    appContext={appContext}
                    topNav={this.props.topNav}
                />
                <VerifyAuctionAccess
                    verifyAuctionAccess={verifyAuctionAccess}
                    registrationToken={registrationToken}
                />
                <flex.components.Footer session={session} appContext={appContext} />
            </>
        );
    };

    routeCreateNewAccount = ({ match }) => {
        const { registrationToken } = match.params;
        const { appContext, session, createNewAccount } = this.props.store;

        return (
            <>
                <flex.components.Header
                    session={session}
                    appContext={appContext}
                    topNav={this.props.topNav}
                />
                <CreateNewAccount
                    registrationToken={registrationToken}
                    createNewAccount={createNewAccount}
                />
                <flex.components.Footer session={session} appContext={appContext} />
            </>
        );
    };

    routeContactUs = () => {
        const store = this.props.store || {};

        return (
            <div>
                <flex.components.Header session={store.session} appContext={store.appContext} topNav={this.props.topNav}></flex.components.Header><ContactUs store={store} />
                <flex.components.Footer session={store.session} appContext={store.appContext}></flex.components.Footer>
            </div>
        );
    };

    routeOAuthCallback = () => {
        return (
            <div>
                <flex.components.OAuthCallback />
            </div>
        );
    };

    routeLanding = () => {
        const { appContext, session, landing } = this.props.store;
        const skinKey = appContext?.app?.skinKey || '';

        const landingContext = require.context('./components/Landing', true, /index.jsx/);
        const landingComponentKey = landingContext.keys().find((componentKey) => {
            return componentKey.toLowerCase().startsWith(`./${skinKey.toLowerCase()}`);
        });

        if (landingComponentKey) {
            const CustomLanding = landingContext(landingComponentKey);

            return <CustomLanding session={session} appContext={appContext} landing={landing} />;
        }

        return <Landing appContext={appContext} landing={landing} />;
    };
}

flex.lib.ReactDOM.render(<flex.AppContainer initStore={{ dataReady: true }}><App hideFooter={true} /></flex.AppContainer>, document.getElementById("app"));
